type LocaleInfo = { timezone: string; currency: string };

const COUNTRY_MAP: Record<string, LocaleInfo> = {
  "united states": { timezone: "America/New_York", currency: "USD" },
  "united states of america": { timezone: "America/New_York", currency: "USD" },
  "usa": { timezone: "America/New_York", currency: "USD" },
  "us": { timezone: "America/New_York", currency: "USD" },
  "united kingdom": { timezone: "Europe/London", currency: "GBP" },
  "uk": { timezone: "Europe/London", currency: "GBP" },
  "great britain": { timezone: "Europe/London", currency: "GBP" },
  "england": { timezone: "Europe/London", currency: "GBP" },
  "scotland": { timezone: "Europe/London", currency: "GBP" },
  "wales": { timezone: "Europe/London", currency: "GBP" },
  "northern ireland": { timezone: "Europe/London", currency: "GBP" },
  "australia": { timezone: "Australia/Sydney", currency: "AUD" },
  "au": { timezone: "Australia/Sydney", currency: "AUD" },
  "canada": { timezone: "America/Toronto", currency: "CAD" },
  "ca": { timezone: "America/Toronto", currency: "CAD" },
  "new zealand": { timezone: "Pacific/Auckland", currency: "NZD" },
  "nz": { timezone: "Pacific/Auckland", currency: "NZD" },
  "germany": { timezone: "Europe/Berlin", currency: "EUR" },
  "deutschland": { timezone: "Europe/Berlin", currency: "EUR" },
  "de": { timezone: "Europe/Berlin", currency: "EUR" },
  "france": { timezone: "Europe/Paris", currency: "EUR" },
  "fr": { timezone: "Europe/Paris", currency: "EUR" },
  "spain": { timezone: "Europe/Madrid", currency: "EUR" },
  "es": { timezone: "Europe/Madrid", currency: "EUR" },
  "italy": { timezone: "Europe/Rome", currency: "EUR" },
  "it": { timezone: "Europe/Rome", currency: "EUR" },
  "netherlands": { timezone: "Europe/Amsterdam", currency: "EUR" },
  "holland": { timezone: "Europe/Amsterdam", currency: "EUR" },
  "nl": { timezone: "Europe/Amsterdam", currency: "EUR" },
  "belgium": { timezone: "Europe/Brussels", currency: "EUR" },
  "be": { timezone: "Europe/Brussels", currency: "EUR" },
  "austria": { timezone: "Europe/Vienna", currency: "EUR" },
  "at": { timezone: "Europe/Vienna", currency: "EUR" },
  "switzerland": { timezone: "Europe/Zurich", currency: "CHF" },
  "ch": { timezone: "Europe/Zurich", currency: "CHF" },
  "sweden": { timezone: "Europe/Stockholm", currency: "SEK" },
  "se": { timezone: "Europe/Stockholm", currency: "SEK" },
  "norway": { timezone: "Europe/Oslo", currency: "NOK" },
  "no": { timezone: "Europe/Oslo", currency: "NOK" },
  "denmark": { timezone: "Europe/Copenhagen", currency: "DKK" },
  "dk": { timezone: "Europe/Copenhagen", currency: "DKK" },
  "finland": { timezone: "Europe/Helsinki", currency: "EUR" },
  "fi": { timezone: "Europe/Helsinki", currency: "EUR" },
  "portugal": { timezone: "Europe/Lisbon", currency: "EUR" },
  "pt": { timezone: "Europe/Lisbon", currency: "EUR" },
  "ireland": { timezone: "Europe/Dublin", currency: "EUR" },
  "ie": { timezone: "Europe/Dublin", currency: "EUR" },
  "greece": { timezone: "Europe/Athens", currency: "EUR" },
  "gr": { timezone: "Europe/Athens", currency: "EUR" },
  "poland": { timezone: "Europe/Warsaw", currency: "PLN" },
  "pl": { timezone: "Europe/Warsaw", currency: "PLN" },
  "czech republic": { timezone: "Europe/Prague", currency: "CZK" },
  "czechia": { timezone: "Europe/Prague", currency: "CZK" },
  "cz": { timezone: "Europe/Prague", currency: "CZK" },
  "hungary": { timezone: "Europe/Budapest", currency: "HUF" },
  "hu": { timezone: "Europe/Budapest", currency: "HUF" },
  "romania": { timezone: "Europe/Bucharest", currency: "RON" },
  "ro": { timezone: "Europe/Bucharest", currency: "RON" },
  "ukraine": { timezone: "Europe/Kiev", currency: "UAH" },
  "ua": { timezone: "Europe/Kiev", currency: "UAH" },
  "russia": { timezone: "Europe/Moscow", currency: "RUB" },
  "ru": { timezone: "Europe/Moscow", currency: "RUB" },
  "turkey": { timezone: "Europe/Istanbul", currency: "TRY" },
  "tr": { timezone: "Europe/Istanbul", currency: "TRY" },
  "south africa": { timezone: "Africa/Johannesburg", currency: "ZAR" },
  "za": { timezone: "Africa/Johannesburg", currency: "ZAR" },
  "nigeria": { timezone: "Africa/Lagos", currency: "NGN" },
  "ng": { timezone: "Africa/Lagos", currency: "NGN" },
  "kenya": { timezone: "Africa/Nairobi", currency: "KES" },
  "ke": { timezone: "Africa/Nairobi", currency: "KES" },
  "ghana": { timezone: "Africa/Accra", currency: "GHS" },
  "gh": { timezone: "Africa/Accra", currency: "GHS" },
  "egypt": { timezone: "Africa/Cairo", currency: "EGP" },
  "eg": { timezone: "Africa/Cairo", currency: "EGP" },
  "india": { timezone: "Asia/Kolkata", currency: "INR" },
  "in": { timezone: "Asia/Kolkata", currency: "INR" },
  "china": { timezone: "Asia/Shanghai", currency: "CNY" },
  "cn": { timezone: "Asia/Shanghai", currency: "CNY" },
  "japan": { timezone: "Asia/Tokyo", currency: "JPY" },
  "jp": { timezone: "Asia/Tokyo", currency: "JPY" },
  "south korea": { timezone: "Asia/Seoul", currency: "KRW" },
  "korea": { timezone: "Asia/Seoul", currency: "KRW" },
  "kr": { timezone: "Asia/Seoul", currency: "KRW" },
  "singapore": { timezone: "Asia/Singapore", currency: "SGD" },
  "sg": { timezone: "Asia/Singapore", currency: "SGD" },
  "malaysia": { timezone: "Asia/Kuala_Lumpur", currency: "MYR" },
  "my": { timezone: "Asia/Kuala_Lumpur", currency: "MYR" },
  "indonesia": { timezone: "Asia/Jakarta", currency: "IDR" },
  "id": { timezone: "Asia/Jakarta", currency: "IDR" },
  "thailand": { timezone: "Asia/Bangkok", currency: "THB" },
  "th": { timezone: "Asia/Bangkok", currency: "THB" },
  "vietnam": { timezone: "Asia/Ho_Chi_Minh", currency: "VND" },
  "vn": { timezone: "Asia/Ho_Chi_Minh", currency: "VND" },
  "philippines": { timezone: "Asia/Manila", currency: "PHP" },
  "ph": { timezone: "Asia/Manila", currency: "PHP" },
  "hong kong": { timezone: "Asia/Hong_Kong", currency: "HKD" },
  "hk": { timezone: "Asia/Hong_Kong", currency: "HKD" },
  "taiwan": { timezone: "Asia/Taipei", currency: "TWD" },
  "tw": { timezone: "Asia/Taipei", currency: "TWD" },
  "pakistan": { timezone: "Asia/Karachi", currency: "PKR" },
  "pk": { timezone: "Asia/Karachi", currency: "PKR" },
  "bangladesh": { timezone: "Asia/Dhaka", currency: "BDT" },
  "bd": { timezone: "Asia/Dhaka", currency: "BDT" },
  "sri lanka": { timezone: "Asia/Colombo", currency: "LKR" },
  "lk": { timezone: "Asia/Colombo", currency: "LKR" },
  "united arab emirates": { timezone: "Asia/Dubai", currency: "AED" },
  "uae": { timezone: "Asia/Dubai", currency: "AED" },
  "ae": { timezone: "Asia/Dubai", currency: "AED" },
  "saudi arabia": { timezone: "Asia/Riyadh", currency: "SAR" },
  "sa": { timezone: "Asia/Riyadh", currency: "SAR" },
  "israel": { timezone: "Asia/Jerusalem", currency: "ILS" },
  "il": { timezone: "Asia/Jerusalem", currency: "ILS" },
  "brazil": { timezone: "America/Sao_Paulo", currency: "BRL" },
  "br": { timezone: "America/Sao_Paulo", currency: "BRL" },
  "mexico": { timezone: "America/Mexico_City", currency: "MXN" },
  "mx": { timezone: "America/Mexico_City", currency: "MXN" },
  "argentina": { timezone: "America/Argentina/Buenos_Aires", currency: "ARS" },
  "ar": { timezone: "America/Argentina/Buenos_Aires", currency: "ARS" },
  "chile": { timezone: "America/Santiago", currency: "CLP" },
  "cl": { timezone: "America/Santiago", currency: "CLP" },
  "colombia": { timezone: "America/Bogota", currency: "COP" },
  "co": { timezone: "America/Bogota", currency: "COP" },
  "peru": { timezone: "America/Lima", currency: "PEN" },
  "pe": { timezone: "America/Lima", currency: "PEN" },
};

export type TimezoneGroup = { label: string; zones: string[] };

const COUNTRY_TIMEZONES: Record<string, string[]> = {
  "united states": [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Anchorage",
    "Pacific/Honolulu",
    "America/Phoenix",
    "America/Indiana/Indianapolis",
  ],
  "united states of america": [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Anchorage",
    "Pacific/Honolulu",
    "America/Phoenix",
    "America/Indiana/Indianapolis",
  ],
  "usa": [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Anchorage",
    "Pacific/Honolulu",
    "America/Phoenix",
    "America/Indiana/Indianapolis",
  ],
  "us": [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Anchorage",
    "Pacific/Honolulu",
    "America/Phoenix",
    "America/Indiana/Indianapolis",
  ],
  "canada": [
    "America/Toronto",
    "America/Vancouver",
    "America/Edmonton",
    "America/Winnipeg",
    "America/Halifax",
    "America/St_Johns",
    "America/Regina",
  ],
  "ca": [
    "America/Toronto",
    "America/Vancouver",
    "America/Edmonton",
    "America/Winnipeg",
    "America/Halifax",
    "America/St_Johns",
    "America/Regina",
  ],
  "australia": [
    "Australia/Sydney",
    "Australia/Melbourne",
    "Australia/Brisbane",
    "Australia/Perth",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Hobart",
  ],
  "au": [
    "Australia/Sydney",
    "Australia/Melbourne",
    "Australia/Brisbane",
    "Australia/Perth",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Hobart",
  ],
  "russia": [
    "Europe/Moscow",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Omsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Yakutsk",
    "Asia/Vladivostok",
    "Asia/Magadan",
    "Asia/Kamchatka",
  ],
  "ru": [
    "Europe/Moscow",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Omsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Yakutsk",
    "Asia/Vladivostok",
    "Asia/Magadan",
    "Asia/Kamchatka",
  ],
  "brazil": [
    "America/Sao_Paulo",
    "America/Fortaleza",
    "America/Recife",
    "America/Bahia",
    "America/Manaus",
    "America/Belem",
    "America/Noronha",
  ],
  "br": [
    "America/Sao_Paulo",
    "America/Fortaleza",
    "America/Recife",
    "America/Bahia",
    "America/Manaus",
    "America/Belem",
    "America/Noronha",
  ],
  "mexico": [
    "America/Mexico_City",
    "America/Cancun",
    "America/Monterrey",
    "America/Hermosillo",
    "America/Chihuahua",
    "America/Tijuana",
  ],
  "mx": [
    "America/Mexico_City",
    "America/Cancun",
    "America/Monterrey",
    "America/Hermosillo",
    "America/Chihuahua",
    "America/Tijuana",
  ],
  "indonesia": [
    "Asia/Jakarta",
    "Asia/Makassar",
    "Asia/Jayapura",
  ],
  "id": [
    "Asia/Jakarta",
    "Asia/Makassar",
    "Asia/Jayapura",
  ],
};

export const COMMON_TIMEZONES: TimezoneGroup[] = [
  {
    label: "Americas",
    zones: [
      "America/New_York",
      "America/Chicago",
      "America/Denver",
      "America/Los_Angeles",
      "America/Anchorage",
      "Pacific/Honolulu",
      "America/Phoenix",
      "America/Toronto",
      "America/Vancouver",
      "America/Halifax",
      "America/Sao_Paulo",
      "America/Argentina/Buenos_Aires",
      "America/Santiago",
      "America/Bogota",
      "America/Lima",
      "America/Mexico_City",
      "America/Caracas",
    ],
  },
  {
    label: "Europe",
    zones: [
      "Europe/London",
      "Europe/Dublin",
      "Europe/Lisbon",
      "Europe/Paris",
      "Europe/Madrid",
      "Europe/Rome",
      "Europe/Berlin",
      "Europe/Amsterdam",
      "Europe/Brussels",
      "Europe/Vienna",
      "Europe/Zurich",
      "Europe/Stockholm",
      "Europe/Oslo",
      "Europe/Copenhagen",
      "Europe/Helsinki",
      "Europe/Warsaw",
      "Europe/Prague",
      "Europe/Budapest",
      "Europe/Bucharest",
      "Europe/Athens",
      "Europe/Kiev",
      "Europe/Moscow",
      "Europe/Istanbul",
    ],
  },
  {
    label: "Africa",
    zones: [
      "Africa/Cairo",
      "Africa/Johannesburg",
      "Africa/Lagos",
      "Africa/Nairobi",
      "Africa/Accra",
      "Africa/Casablanca",
    ],
  },
  {
    label: "Asia",
    zones: [
      "Asia/Dubai",
      "Asia/Riyadh",
      "Asia/Jerusalem",
      "Asia/Karachi",
      "Asia/Kolkata",
      "Asia/Dhaka",
      "Asia/Colombo",
      "Asia/Bangkok",
      "Asia/Jakarta",
      "Asia/Singapore",
      "Asia/Kuala_Lumpur",
      "Asia/Manila",
      "Asia/Ho_Chi_Minh",
      "Asia/Hong_Kong",
      "Asia/Shanghai",
      "Asia/Taipei",
      "Asia/Tokyo",
      "Asia/Seoul",
    ],
  },
  {
    label: "Oceania",
    zones: [
      "Australia/Sydney",
      "Australia/Melbourne",
      "Australia/Brisbane",
      "Australia/Perth",
      "Australia/Adelaide",
      "Australia/Darwin",
      "Pacific/Auckland",
      "Pacific/Fiji",
    ],
  },
];

export function getTimezonesForCountry(country: string): TimezoneGroup[] | null {
  if (!country || !country.trim()) return null;
  const normalized = country.toLowerCase().trim();
  if (COUNTRY_TIMEZONES[normalized]) {
    return [{ label: country, zones: COUNTRY_TIMEZONES[normalized] }];
  }
  for (const [key, zones] of Object.entries(COUNTRY_TIMEZONES)) {
    if (key.length <= 2) continue;
    if (wordBoundaryMatch(normalized, key)) {
      return [{ label: key, zones }];
    }
  }
  const singleZone = detectLocaleFromCountry(country);
  if (singleZone) {
    return [{ label: country, zones: [singleZone.timezone] }];
  }
  return null;
}

function wordBoundaryMatch(line: string, phrase: string): boolean {
  const escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`(?<![a-z])${escaped}(?![a-z])`, "i");
  return re.test(line);
}

export function detectLocaleFromCountry(country: string): LocaleInfo | null {
  if (!country || !country.trim()) return null;
  const normalized = country.toLowerCase().trim();
  if (COUNTRY_MAP[normalized]) return COUNTRY_MAP[normalized];
  for (const [key, info] of Object.entries(COUNTRY_MAP)) {
    if (key.length <= 2) continue;
    if (wordBoundaryMatch(normalized, key)) return info;
  }
  return null;
}

export function detectLocaleFromAddress(address: string): LocaleInfo | null {
  if (!address || !address.trim()) return null;

  const lines = address
    .split(/[\n,]/)
    .map((l) => l.trim())
    .filter(Boolean);

  if (lines.length === 0) return null;

  for (const line of [...lines].reverse()) {
    const normalized = line.toLowerCase().trim();
    if (!normalized) continue;

    if (COUNTRY_MAP[normalized]) {
      return COUNTRY_MAP[normalized];
    }

    for (const [key, info] of Object.entries(COUNTRY_MAP)) {
      if (key.length <= 2) {
        continue;
      }
      if (wordBoundaryMatch(normalized, key)) {
        return info;
      }
    }
  }

  return null;
}
